export default __webpack_public_path__ + "static/media/gallery_03.f32f7d44.jpg";